import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './ClientFeedbackModal.scss';

export default class ClientFeedbackModal extends Component {
    static get propTypes() {
        return {
            onAnswerClick: PropTypes.func,
            ltk: PropTypes.string,
            ft: PropTypes.string, 
            isBuyer: PropTypes.bool,
            dynamicModules: PropTypes.string,
            agentId: PropTypes.string,
        };
    }

    componentDidMount() {
        if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
            const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
            UpNestAnalytics.trackEvent("modalImpression", {
                pageId: "proposal",
                modalName: 'client_feedback_modal',
                modalTrigger: `${sell_or_buy}:proposal:client_feedback${this.props?.ltk ? '_ltk' : ''}${this.props?.ft ? '_ft' : ''}`,
                pageType: "proposal",
                siteSection: sell_or_buy,
                rdcTrackingEnabled: "y",
                dynamicModules: this.props?.dynamicModules,
                agentId: this.props?.agentId
            });
        }
    }

    onAnswerClick(answer) {
        this.props?.onAnswerClick && this.props?.onAnswerClick(answer);
        if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
            const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
            UpNestAnalytics.trackEvent("click", {
                pageId: "proposal",
                linkName: `client_feedback:${answer}`,
                modalName: 'client_feedback_modal',
                modalTrigger: `${sell_or_buy}:proposal:client_feedback${this.props?.ltk ? '_ltk' : ''}${this.props?.ft ? '_ft' : ''}`,
                pageType: "proposal",
                siteSection: sell_or_buy,
                rdcTrackingEnabled: "y",
                dynamicModules: this.props?.dynamicModules,
                agentId: this.props?.agentId,
            });
        }
    }

    render() {
        return (
            <div className="modal nu-modal upnest-modal client-feedback-modal fade" role="dialog">
                <div className="modal-dialog client-feedback-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                What do you think of this agent?
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-gray-outline interested"
                                data-dismiss="modal"
                                onClick={() => this.onAnswerClick('Interested')}>
                                <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#prefix__clip0)" fill="#5CBE85"><path d="M1.667 7C.748 7 0 7.748 0 8.667V14c0 .919.748 1.667 1.667 1.667h2c.375 0 .72-.127 1-.338V7h-3zM16 9.5c0-.4-.159-.774-.434-1.05.311-.34.47-.797.427-1.272-.078-.847-.841-1.511-1.739-1.511h-4.118c.204-.62.53-1.755.53-2.667 0-1.446-1.228-2.667-2-2.667-.692 0-1.187.39-1.208.406A.335.335 0 007.333 1v2.26l-1.92 4.16-.08.04v7.146C5.877 14.862 6.563 15 7 15h6.12c.726 0 1.36-.49 1.51-1.165a1.5 1.5 0 00-.12-1.001 1.493 1.493 0 00.667-2c.492-.249.823-.756.823-1.334z"/></g><defs><clipPath id="prefix__clip0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
                                Interested
                            </button>
                            <button
                                type="button"
                                className="btn btn-gray-outline not-interested"
                                data-dismiss="modal"
                                onClick={() => this.onAnswerClick('NotInterested')}>
                                <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#prefix__clip0)" fill="#EB5757"><path d="M14.333 9C15.252 9 16 8.252 16 7.333V2c0-.919-.748-1.667-1.667-1.667h-2c-.375 0-.72.127-1 .338V9h3zM0 6.5c0 .4.159.774.434 1.05-.311.34-.47.797-.427 1.272.078.847.842 1.511 1.739 1.511h4.118c-.204.62-.53 1.755-.53 2.667 0 1.446 1.228 2.667 2 2.667.692 0 1.187-.39 1.208-.406A.335.335 0 008.666 15v-2.26l1.92-4.16.08-.04V1.393C10.124 1.138 9.438 1 9 1H2.88c-.725 0-1.36.49-1.51 1.165a1.5 1.5 0 00.12 1.001 1.493 1.493 0 00-.667 2A1.492 1.492 0 000 6.5z"/></g><defs><clipPath id="prefix__clip0"><path fill="#fff" transform="rotate(180 8 8)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
                                Not Interested
                            </button>
                            <button
                                type="button"
                                className="btn btn-gray-outline"
                                data-dismiss="modal"
                                onClick={() => this.onAnswerClick('NotSure')}>
                                Not Sure
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
